import { jsx as _jsx } from "react/jsx-runtime";
import { useFormikContext } from 'formik';
import lodashGet from 'lodash/get';
import { useCallback } from 'react';
import NumberInput from '../NumberInput';
function FormikNumberInput(props) {
    const { label, name, ...resProps } = props;
    const { values, handleChange } = useFormikContext();
    const changeHandler = useCallback((e) => {
        handleChange(e);
    }, [handleChange]);
    return (_jsx(NumberInput, { label: label, name: name, defaultValue: lodashGet(values, name), onChange: changeHandler, ...resProps }));
}
export default FormikNumberInput;
